import { HttpErrorResponse } from '@angular/common/http';

/**
 * Error normalizado del backend.
 *
 * El backend responde con `detail` (ver ErrorBackend) o con un mapa de errores
 * por campo cuando falla la validación de un serializer. Esta clase deja siempre
 * un `message` legible para mostrar en la UI.
 */
export class ErrorFrontend extends Error {
  readonly status: number;
  readonly datos: unknown;
  /**
   * Detalle fino que acompaña al mensaje, cuando el backend lo manda.
   *
   * Ej.: al subir un Excel con filas malas, `message` es "El archivo tiene
   * errores." y aquí vienen los "Fila 3: ..." para poder listarlos.
   */
  readonly errores: string[] | null;

  constructor(origen: unknown) {
    let mensaje = 'Error desconocido';
    let status = 0;
    let datos: unknown = null;
    let errores: string[] | null = null;

    if (typeof origen === 'string') {
      mensaje = origen;
    } else if (origen instanceof HttpErrorResponse) {
      status = origen.status;
      datos = origen.error;
      const error = origen.error;

      if (status === 0) {
        mensaje = 'No se pudo conectar con el servidor.';
      } else if (typeof error === 'string') {
        mensaje = error;
      } else if (error?.detail) {
        mensaje = error.detail;
      } else if (error && typeof error === 'object') {
        // Errores de validación por campo: { campo: ["mensaje"] }
        const [campo, valor] = Object.entries(error)[0] ?? [];
        if (campo) {
          const texto = Array.isArray(valor) ? valor[0] : String(valor);
          mensaje = campo === 'non_field_errors' ? texto : `${campo}: ${texto}`;
        }
      }

      if (Array.isArray(error?.errores) && error.errores.length) {
        errores = error.errores.map((e: unknown) => String(e));
      }
    }

    super(mensaje);
    this.name = 'ErrorFrontend';
    this.status = status;
    this.datos = datos;
    this.errores = errores;
  }
}
